<mat-toolbar class="primary">
  <span class="adx-address-book-icon"><i class="fa-solid fa-address-book"></i></span>
  {{'ASTIMAX.CONTACT.WIDGET.EDIT_MANUAL_CONTACT' | translate }}
  <span class="adx-toolbar-spacer"></span>
  <button mat-icon-button
    [mat-dialog-close]="false"
    aria-label="Close Button"
    matTooltip="{{'ASTIMAX.CONTACT.WIDGET.CLOSE' | translate }}">
    <fa-icon [icon]="'xmark'"></fa-icon>
  </button>
</mat-toolbar>

<mat-dialog-content class="adx-dialog-content-wrapper">
  <!-- Contact Info Header -->
  <div class="adx-contact-header">
    <div class="adx-contact-meta">
      <span>{{'ASTIMAX.CONTACT.WIDGET.NAME' | translate }}: {{ data.contact.name }}</span>
      <div class="contact-avatar">
        @if (data.contact.avatar) {
          <img
            [src]="data.contact.avatar"
            [alt]="data.contact.name"
            class="avatar-image">
        }
        @if (!data.contact.avatar) {
          <div
            class="avatar-initials">
            {{'ASTIMAX.CONTACT.WIDGET.INITIALS' | translate }}: {{ getInitials(contactName || data.contact.name) }}
          </div>
        }
      </div>
      <div class="contact-dates">
        @if (data.contact?.created) {
          <p>
            {{'ASTIMAX.CONTACT.WIDGET.CREATED' | translate }}:
            {{ data.contact?.created |  date:'short':'':'de-DE' }}
          </p>
        }
        @if (data.contact?.updated) {
          <p>
            {{'ASTIMAX.CONTACT.WIDGET.LAST_UPDATED' | translate }}:
            {{ data.contact.updated |  date:'short':'':'de-DE' }}
          </p>
        }
      </div>
    </div>
  </div>

  <form #contactForm="ngForm" novalidate class="edit-form">
    <!-- Name Field -->
    <mat-form-field appearance="outline" class="adx-full-width">
      <mat-label>{{'ASTIMAX.CONTACT.WIDGET.NAME' | translate }}</mat-label>
      <input
        matInput
        [(ngModel)]="contactName"
        name="contactName"
        #nameInput="ngModel"
        placeholder="{{'ASTIMAX.CONTACT.WIDGET.ENTER_CONTACT_NAME' | translate }}"
        aria-label="Contact name"
        maxlength="100"
        required
        minlength="2"
        type="text"
        autocomplete="name">
        @if (nameInput.invalid && nameInput.touched) {
          <mat-error>
            @if (nameInput.errors?.['required']) {
              <span>{{'ASTIMAX.CONTACT.WIDGET.NAME_REQUIRED' | translate }}</span>
            }
            @if (nameInput.errors?.['minlength']) {
              <span>{{'ASTIMAX.CONTACT.WIDGET.NAME_MIN_LENGTH' | translate }}</span>
            }
          </mat-error>
        }
      </mat-form-field>

      <!-- Phone Number Field -->
      <mat-form-field appearance="outline" class="adx-full-width">
        <mat-label>{{'ASTIMAX.CONTACT.WIDGET.PHONE_NUMBER' | translate }}</mat-label>
        <input
          matInput
          [(ngModel)]="phoneNumber"
          name="phoneNumber"
          #phoneInput="ngModel"
          placeholder="{{'ASTIMAX.CONTACT.WIDGET.ENTER_PHONE_NUMBER' | translate }}"
          aria-label="Phone number"
          maxlength="50"
          required
          type="tel"
          autocomplete="tel">
          @if (phoneInput.invalid && phoneInput.touched) {
            <mat-error>
              @if (phoneInput.errors?.['required']) {
                <span>{{'ASTIMAX.CONTACT.WIDGET.PHONE_REQUIRED' | translate }}</span>
              }
            </mat-error>
          }
        </mat-form-field>

        <!-- Changes Summary -->
        @if (hasChanges()) {
          <div class="changes-summary">
            <div class="changes-content">
              <p>
                <i class="fas fa-pen changes-icon" aria-hidden="true"></i>
                {{'ASTIMAX.CONTACT.WIDGET.PENDING_CHANGES' | translate }}
              </p>
              @if (contactName !== data.contact.name) {
                <div class="change-item">
                  <strong>{{'ASTIMAX.CONTACT.WIDGET.NAME' | translate }}:</strong>
                  <span class="adx-old-value">"{{ data.contact.name }}"</span>
                  <i class="fas fa-arrow-circle-right arrow-icon" aria-hidden="true"></i>
                  <span class="adx-new-value">"{{ contactName }}"</span>
                </div>
              }
              @if (phoneNumber !== data.contact.phoneNumber) {
                <div class="change-item">
                  <strong>{{'ASTIMAX.CONTACT.WIDGET.PHONE_NUMBER' | translate }}:</strong>
                  <span class="adx-old-value">"{{ data.contact.phoneNumber }}"</span>
                  <i class="fas fa-arrow-circle-right arrow-icon" aria-hidden="true"></i>
                  <span class="adx-new-value">"{{ phoneNumber }}"</span>
                </div>
              }
            </div>
          </div>
        }
      </form>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button
        mat-raised-button
        (click)="onCancel()"
        type="button"
        aria-label="Cancel editing"
        matTooltip="{{'ASTIMAX.CONTACT.WIDGET.CANCEL' | translate }}">
        {{'ASTIMAX.CONTACT.WIDGET.CANCEL' | translate }}
      </button>
      <button
        mat-raised-button
        class="primary"
        type="button"
        (click)="onSave()"
        [disabled]="!isFormValid() || !hasChanges()"
        [attr.aria-label]="canSave() ? 'Save changes' : 'Cannot save - no changes or form invalid'"
        matTooltip="{{'ASTIMAX.CONTACT.WIDGET.SAVE' | translate }}">
        {{'ASTIMAX.CONTACT.WIDGET.SAVE' | translate }}
      </button>
    </mat-dialog-actions>
